import { LANG_CODES_KEYS, PREFERRED_LANGS } from "../constants"

export const localStorage = window.localStorage

export const setItem = (storage, key, value) => {
  try {
    storage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.error(e)
  }
}

export const getItem = (storage, key) => {
  try {
    const item = storage.getItem(key)
    return JSON.parse(item)
  } catch (e) {
    return undefined
  }
}

export const removeItem = (storage, key) => {
  try {
    storage.removeItem(key)
  } catch (e) {
    console.error(e)
  }
}

/** Language code storage by admin/superadmin */

export const getLangCode = (isAdmin) => {
  var value = isAdmin ? LANG_CODES_KEYS.i18nLang : LANG_CODES_KEYS.i18nLangSAdmin;
  return getItem(localStorage, value) || PREFERRED_LANGS[0].value;
}

export const setLangCode = (isAdmin, language) => {
  var value = isAdmin ? LANG_CODES_KEYS.i18nLang : LANG_CODES_KEYS.i18nLangSAdmin;
  setItem(localStorage, value, language);
}

export const removeLangCode = (isAdmin) => {
  var value = isAdmin ? LANG_CODES_KEYS.i18nLang : LANG_CODES_KEYS.i18nLangSAdmin;
  removeItem(localStorage, value);
}

export const clearLangCode = () => {
  removeItem(localStorage, LANG_CODES_KEYS.i18nLang);
  removeItem(localStorage, LANG_CODES_KEYS.i18nLangSAdmin);
}